import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Contact from "./pages/Contact";
import RetourAffectif from "./pages/RetourAffectif";
import Voyance from "./pages/Voyance";
import Guerisseur from "./pages/Guerisseur";
import Blog from "./pages/Blog";
import VilleSEO from "./pages/VilleSEO";
import MentionsLegales from "./pages/MentionsLegales";
import ServicePage from "./pages/ServicePage";
import Articles from "./pages/Articles";
import ArticlePage from "./pages/ArticlePage";
import SeoManager from "./seo/SeoManager";
import { servicesSeo } from "./servicesSeo";
import { Toaster } from "./components/ui/toaster";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SeoManager />
        <Routes>
          {servicesSeo.map((s) => (
            <Route key={s.slug} path={`/${s.slug}`} element={<ServicePage service={s} />} />
          ))}
          <Route path="/articles" element={<Articles />} />
          <Route path="/articles/:slug" element={<ArticlePage />} />
          <Route path="/" element={<Home />} />
          <Route path="/retour-affectif" element={<RetourAffectif />} />
          <Route path="/voyance" element={<Voyance />} />
          <Route path="/guerisseur" element={<Guerisseur />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/marabout/:slug" element={<VilleSEO />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
